import React from "react";
const BreadCrumb = () => {
    return(
        <ul className="collapsed">
                  <li>
                    <a href="#">Home</a>
                  </li>
                  {/*
                   */}
                  <li>
                    <a href="#">Categories</a>
                  </li>
                  <li>
                    <a href="#">Womens</a>
                  </li>
                  <li>
                    <a href="#">Casuals</a>
                  </li>
                  <li>
                    <a href="#">RELAXED.....</a>
                  </li>
               </ul> 
    )
}
export default BreadCrumb;